
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface Driver {
  id: string;
  supplier_id: string;
  supervisor_id: string;
  name_ar: string;
  name_en: string;
  mobile: string;
  email: string;
  has_access_permission: boolean;
  suppliers: { name_ar: string };
  employees: { name: string };
  created_at: string;
}

interface DriverCardProps {
    driver: Driver;
    onEdit: (driver: Driver) => void;
    onDelete: (id: string) => void;
}

export function DriverCard({ driver, onEdit, onDelete }: DriverCardProps) {
    return (
        <Card>
            <CardHeader>
                <CardTitle>{driver.name_ar}</CardTitle>
                {driver.name_en && (
                <p className="text-gray-600">{driver.name_en}</p>
                )}
            </CardHeader>
            <CardContent>
                <div className="space-y-2">
                    <p><strong>المورد:</strong> {driver.suppliers?.name_ar || 'غير محدد'}</p>
                    <p><strong>المشرف:</strong> {driver.employees?.name || 'غير محدد'}</p>
                    {driver.mobile && (
                        <p><strong>الموبايل:</strong> {driver.mobile}</p>
                    )}
                    {driver.email && (
                        <p><strong>البريد:</strong> {driver.email}</p>
                    )}
                    <p>
                        <strong>صلاحيات الدخول:</strong>{" "}
                        <span className={driver.has_access_permission ? "text-green-600" : "text-red-600"}>
                        {driver.has_access_permission ? "نعم" : "لا"}
                        </span>
                    </p>
                </div>
                <div className="flex gap-2 mt-4">
                    <Button size="sm" onClick={() => onEdit(driver)}>
                        تعديل
                    </Button>
                    <Button 
                        size="sm" 
                        variant="destructive" 
                        onClick={() => onDelete(driver.id)}
                    >
                        حذف
                    </Button>
                </div>
            </CardContent>
        </Card>
    )
}
